// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Pps1","productName":"Table_productName__10nGy"};